const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_pages/$lang/stores/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_pages/$lang/stores/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { alternatesToLinks, buildLocalizedPageAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_pages/$lang/stores/")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    return {
      meta: await buildPagePreviewMetaTags({
        title: t("stores"),
        description: t("storesDescription"),
        canonicalUrl: buildLocalizedPageAlternates(locale, "stores").canonical
      }, {}, {
        locale
      }),
      links: alternatesToLinks(buildLocalizedPageAlternates(locale, "stores"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});